import React, {Component} from 'react'


import { Image, Video } from "../../components";
import Visible from '../Visible'

class Media extends Component {

	render()
	{
		let {src,mobileSrc,view,hasAudio,kind,fluid,ratio,controls,autoplay,playOnVisible, className,poster} = this.props
		
		let ret = null
		
		switch(kind)
		{
			case 'video':
				ret = <Video view={view} src={src} mobileSrc={mobileSrc} poster={poster} hasAudio={hasAudio} fluid={fluid} ratio={ratio} controls={controls} autoplay={autoplay} className={className} playOnVisible={playOnVisible} />
				break
			default: 
				ret = <Image view={view} src={src} mobileSrc={mobileSrc} fluid={fluid} className={className} ratio={ratio} />
				break
		}

		return <Visible>{ret}</Visible>

		
	}

}

export default Media


// WEBPACK FOOTER //
// ./src/js/components/Media/Media.jsx